import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-scm-kpi',
  templateUrl: './scm-kpi.component.html',
  styleUrls: ['./scm-kpi.component.css']
})
export class ScmKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi5: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  ScmKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi4: boolean = false;
  manfMonthFilterKpi4: monthFilter;

  Highcharts = Highcharts;

  totalDataSCM: any;
  totalDataKpiChartOptionsSCM: Highcharts.Options;
  panelWiseDataSCM: any;
  panelWiseKpiChartOptionsSCM: Highcharts.Options;

  
  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-5', this.isManfMonthFilterSelectedKpi4 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi4) {
      this._dataService.setCookie('s-manfmonth-val-kpi-5', this.manfMonthFilterKpi4.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-5');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi4 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-5');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi4 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi4 == null) {
      this.manfMonthFilterKpi4 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi5 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi4 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi4 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpScmKpi: Array<UiFunctionalKPI> = [];

    let _totalQtySCM: number = 0;
    let _delayQtySCM: number = 0;
    let _onTimeQtySCM: number = 0;
    let _delayQtySCMZS1: number = 0;
    let _onTimeQtySCMZS1: number = 0;
    let _delayQtySCMZS1DBB: number = 0;
    let _onTimeQtySCMZS1DBB: number = 0;
    let _delayQtySCMZS2: number = 0;
    let _onTimeQtySCMZS2: number = 0;
    let _delayQtySCMZS9: number = 0;
    let _onTimeQtySCMZS9: number = 0;
    let _delayQtySCMZN1: number = 0;
    let _onTimeQtySCMZN1: number = 0;

   

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi5.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi5[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for CT Finalization planned and Actual Dates      

            if (_tmpSSO.scmIP.ctFinalizationFromSCMPlannedDate != null && _tmpSSO.scmIP.ctFinalizationFromSCMActualDate != null) {


              // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtySCM += temp;
                }
              }
            });

            let isRevisedSCM = _tmpSSO.scmIP.ctFinalizationFromSCMPlannedDateIsRevised;

              let _sCMPlanned = _tmpSSO.scmIP.ctFinalizationFromSCMPlannedDate.getTime();
              let _sCMActual = _tmpSSO.scmIP.ctFinalizationFromSCMActualDate.getTime();
              let _sCMDiff_time = _sCMPlanned - _sCMActual;
              let _sCMDiff = _sCMDiff_time / (1000 * 3600 * 24);

              // CT Finalization Delay
              if (_sCMDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtySCM += temp;
                    }
                  }
                });

                let _individualDelayQtySCM = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCMZS1 += temp;
                          _individualDelayQtySCM += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCMZS1DBB += temp;
                          _individualDelayQtySCM += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCMZS2 += temp;
                          _individualDelayQtySCM += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCMZN1 += temp;
                          _individualDelayQtySCM += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCMZS9 += temp;
                          _individualDelayQtySCM += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedSCM == true? null: _tmpSSO.scmIP.ctFinalizationFromSCMPlannedDate
                let _revisedTmp = isRevisedSCM == false? null:_tmpSSO.scmIP.ctFinalizationFromSCMPlannedDate
                
                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'SCM', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtySCM, _plannedTmp, _revisedTmp, null, _tmpSSO.scmIP.ctFinalizationFromSCMActualDate, _sCMDiff,_tmpSSO.pmTechSubSalesOrder.actualCtFinalizationToken.addNotes)

                _tmpScmKpi.push(_tmpSSOobj);
              }
              // CT Finalization on Time
              if (_sCMDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtySCM += temp;
                    }
                  }
                });

                let _individualOnTimeQtySCM = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCMZS1 += temp;
                          _individualOnTimeQtySCM += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCMZS1DBB += temp;
                          _individualOnTimeQtySCM += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCMZS2 += temp;
                          _individualOnTimeQtySCM += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCMZN1 += temp;
                          _individualOnTimeQtySCM += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCMZS9 += temp;
                          _individualOnTimeQtySCM += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedSCM == true? null: _tmpSSO.scmIP.ctFinalizationFromSCMPlannedDate
                let _revisedTmp = isRevisedSCM == false? null:_tmpSSO.scmIP.ctFinalizationFromSCMPlannedDate
                
                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'SCM', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtySCM, _plannedTmp, _revisedTmp, null, _tmpSSO.scmIP.ctFinalizationFromSCMActualDate, _sCMDiff,_tmpSSO.pmTechSubSalesOrder.actualCtFinalizationToken.addNotes)

                _tmpScmKpi.push(_tmpSSOobj);
              }


            }

          });

        }


      }

    }

    if (_totalQtySCM != 0 || _onTimeQtySCM != 0 || _delayQtySCM != 0) {
      this.totalDataSCM = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtySCM,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtySCM,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtySCM,
        }]
      }

      ];
    }
    else { this.totalDataSCM = null; }

    this.totalDataKpiChartOptionsSCM = this._kpiCharServ.getTotalDataChartOptions(this.totalDataSCM);

    if (_onTimeQtySCMZN1 != 0 || _onTimeQtySCMZS9 != 0 || _onTimeQtySCMZS1 != 0 || _onTimeQtySCMZS1DBB != 0 || _onTimeQtySCMZS2 != 0
      || _delayQtySCMZN1 != 0 || _delayQtySCMZS9 != 0 || _delayQtySCMZS1 != 0 || _delayQtySCMZS1DBB != 0 || _delayQtySCMZS2 != 0) {

      this.panelWiseDataSCM = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtySCMZN1, _onTimeQtySCMZS9, _onTimeQtySCMZS1, _onTimeQtySCMZS1DBB, _onTimeQtySCMZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtySCMZN1, _delayQtySCMZS9, _delayQtySCMZS1, _delayQtySCMZS1DBB, _delayQtySCMZS2],
      }

      ];
    }
    else { this.panelWiseDataSCM = null; }

    this.panelWiseKpiChartOptionsSCM = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataSCM);

    

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.ScmKpi = _tmpScmKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi4 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi4) {
      return this.manfMonthFilterKpi4.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi4) {
      return this.manfMonthFilterKpi4.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi4.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi4.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi4.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi4.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi4 == true && this.manfMonthFilterKpi4 != null) {
      if (this.manfMonthFilterKpi4.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }


}
